import axios from 'axios';
import getConfig from '../config/environments';
import authFusionService from './authfusion';

const config = getConfig();

export function applyAuthInterceptors(instance, options = {}) {
  const redirectOnUnauthorized = options.redirectOnUnauthorized !== false;

  instance.interceptors.request.use(
    (cfg) => {
      const token = authFusionService.getAccessToken();
      if (token) {
        cfg.headers.Authorization = `Bearer ${token}`;
      }
      return cfg;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const status = error.response?.status;
      const errorCode = error.response?.data?.errorCode;
      const shouldRetryAuth =
        !originalRequest._retry &&
        (status === 401 || (status === 400 && errorCode === 'auth.unauthorized'));

      if (shouldRetryAuth) {
        originalRequest._retry = true;

        try {
          const refreshedUser = await authFusionService.startSilentRenew();
          if (refreshedUser?.access_token) {
            originalRequest.headers.Authorization = `Bearer ${refreshedUser.access_token}`;
            return instance(originalRequest);
          }
        } catch {
          // silent renew failed
        }

        if (redirectOnUnauthorized) {
          // Refresh failed (refresh token expired or revoked): end the session
          // so the app shows the embedded sign-in form, instead of bouncing the
          // operator to the hosted FusionAuth page.
          await authFusionService.endExpiredSession();
        }
      }

      return Promise.reject(error);
    },
  );

  return instance;
}

const api = applyAuthInterceptors(
  axios.create({
    baseURL: config.api.baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
);

export const gatewayApi = applyAuthInterceptors(
  axios.create({
    baseURL: config.api.gatewayURL,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
);

export default api;
